<app-page-content [showProgress]="deleting || saving" [title]="isNewDefinition() ? 'Ny avviksårsak' : 'Rediger avviksårsak'">
  <span pagetitle>{{ isNewDefinition() ? 'Ny avviksårsak' : 'Rediger avviksårsak' }}</span>

  <form pagecontent [formGroup]="formGroup" style="padding: 0.5em; display: flex; flex-direction: column">
    <mat-form-field style="width: 100%" floatLabel="always">
      <mat-label>Navn</mat-label>
      <input matInput formControlName="Name" required>
    </mat-form-field>
    <mat-form-field style="width: 30%" floatLabel="always">
      <mat-label>Type</mat-label>
      <mat-select formControlName="Type" required>
        <mat-option value="Parcel">Kolli</mat-option>
        <mat-option value="Shipment">Sending</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field style="width: 30%" floatLabel="always">
      <mat-label>Kontekst</mat-label>
      <mat-select formControlName="Context">
        <mat-option value="PickUp">Henting</mat-option>
        <mat-option value="Delivery">Levering</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-slide-toggle formControlName="ImagesEnabled">Bilder aktivert</mat-slide-toggle>
    <mat-slide-toggle style="margin-top: 1em" formControlName="CommentEnabled">Kommentar aktivert</mat-slide-toggle>
  </form>

  <app-button-box pagefooter>
    <button color="warn" (click)="cancel()" mat-raised-button>AVBRYT</button>
    <button color="primary" (click)="save()" mat-raised-button>LAGRE</button>
  </app-button-box>

  <app-button-box pageheaderactions>
    <button *ngIf="!isNewDefinition()" style="margin-right: 1em;" color="warn" (click)="deleteDefinition()" mat-raised-button>SLETT</button>
  </app-button-box>
</app-page-content>
